import {h, Fragment} from "preact"
import { useActions, useAppState } from '@nosto/preact'
import Facet from './Facet'
import RangeFacet from './RangeFacet'
import { defaultConfig, sortOptions } from '../config'
import { useState } from 'preact/hooks'

export default () => {
    const { loading, query, response, response: { products: { facets } } = {} } = useAppState()
    const { updateSearch } = useActions()
    const [activeFacet, setActiveFacet] = useState('')
    const [isSortingActive, setIsSortingActive] = useState(false)

    const activeSort =
        sortOptions.find((option) =>
            option.value.sort.every((v1) =>
                query.products?.sort?.find((v2) => v1.field === v2.field && v1.order === v2.order)
            )
        )?.id ?? defaultConfig.sort.id

    const docCount = response.products?.total ?? 0

    return facets?.length > 0 ? (
        <>
            {/* Desktop */}
            <div
                class="ns-sidebar-wrapper ns-d-none ns-d-md-block ns-h-100"
                style={loading ? 'opacity: 0.3;' : ''}>
                {query.query != undefined && (
                    <div class="nosto-search-header">
                        <h3>
                            Found {docCount} results for '{query.query}'
                        </h3>
                    </div>
                )}
                <div class="ns-sidebar-content ns-relative ns-h-100 ns-mr-0 ns-mr-md-auto">
                    <div class="ns-sidebar-menu">
                        <ul class="ns-list-unstyled ns-p-0 ns-m-0">
                            {facets?.map((facet) => {
                                switch (facet.type) {
                                    case 'terms':
                                        return (
                                            <Facet
                                                facet={facet}
                                                isActive={activeFacet === facet.id}
                                                setActive={(active) => {
                                                    if (active) {
                                                        setActiveFacet(facet.id)
                                                    } else {
                                                        setActiveFacet('')
                                                    }
                                                }}
                                            />
                                        )
                                    case 'stats':
                                        return <RangeFacet facet={facet} />
                                    default:
                                        return null
                                }
                            })}
                            <li
                                class="ns-results-number nosto-hide-on-mobile"
                                style="display: flex; align-items: center;">
                                <span>{response.products?.total} items</span>
                            </li>
                        </ul>
                        <div class={`ns-sorting ns-sidebar-dropdown ${isSortingActive ? 'ns-active' : ''}`}>
                            <div class="ns-d-flex ns-align-items-center">
                                <span class="ns-sort-by">Sort By: </span>
                                <a
                                    class="nosto-sidebar-dropdown ns-d-inline-block ns-relative ns-w-100 ns-border-box ns-text-undecorated"
                                    href="javascript:void(0)"
                                    onClick={() => {
                                        setIsSortingActive(!isSortingActive)
                                    }}>
                                    <span class="ns-color-link ns-font-4">
                                        {sortOptions.find((option) => option.id === activeSort)?.value.name}
                                    </span>
                                    <i class="ns-icon ns-icon-arrow ns-absolute"></i>
                                </a>
                            </div>

                            <div class="ns-sidebar-submenu ns-d-none ns-p-4">
                                <ul class="ns-list-unstyled ns-p-0 ns-m-0">
                                    {sortOptions.map((option) => (
                                        <li class="ns-mobile-facet-filter ns-d-flex ns-justify-content-between ns-align-items-center ns-font-3">
                                            <label class="ns-checkbox ns-d-block ns-color-grey-dark">
                                                {option.value.name}
                                                <input
                                                    type="radio"
                                                    checked={activeSort === option.id}
                                                    onChange={() => {
                                                        updateSearch({
                                                            products: {
                                                                sort: option.value.sort,
                                                            },
                                                        })
                                                        setIsSortingActive(false)
                                                    }}
                                                />
                                                {/* <span class="ns-checkmark"></span> */}
                                                <span class="ns-checkmark-mobile"></span>
                                            </label>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    ) : (
        ''
    )
}
